import React, { useEffect } from 'react';
import { BooleanInput, Filter, minValue, SearchInput, SelectInput,AutocompleteInput,DateInput } from 'react-admin';



const FiltreFrete=(props)=>{

    //const [listCamps, setListCamps] = useState([]);
    //const notify = useNotify();
    const {listCamps}=props;
    useEffect(() => {


    }, []);

    return (
        <Filter {...props} >
            <SearchInput source="q" alwaysOn  validate={minValue(4)} />
            <DateInput source="start_date" label="Date début"  alwaysOn />
            <DateInput source="end_date" label="Date fin"  alwaysOn />
            <AutocompleteInput
                source="camp_id"
                label="Campagne" 
                choices={listCamps}
                allowEmpty={false}
                //defaultValue={listCamps && listCamps.length>0 ? listCamps[0].id:0}
            />
            <BooleanInput  source="urgent" fullWidth label="Urgent"   />
            <BooleanInput  source="rest_a_payer" label="Reste à payer"   />
            <BooleanInput  source="gratuit_excep"  label="Gratuit exceptionnel"  />
            <SelectInput
                source="client"
                label="Client" 
                choices={[
                    { id: 'cli_exp', name: 'Nom Client exp' },
                    { id: 'tel_exp', name: 'Tel Client exp' },
                    { id: 'cli_dest', name: 'Nom Client dest' },
                    { id: 'tel_dest', name: 'Tel Client dest' },
                ]}
            />

        </Filter>
    );

}

export default FiltreFrete;